import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../services/api";
// import Navbar from "../components/Layout/Navbar";

/* Email masking helper */
const maskEmail = (email) => {
  if (!email) return "";
  const [name, domain] = email.split("@");
  if (!name || !domain) return email;
  return `${name[0]}***@${domain}`;
};

export default function EmailVerifyPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef(null);

  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    }
    inputRef.current?.focus();
  }, [location.state]);

  useEffect(() => {
    if (timer <= 0) return;
    const interval = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return;

    setLoading(true);
    setMessage("");

    try {
      const res = await api.post("/auth/verify", { email, code });

      if (res.data?.success) {
        setSuccess(true);
        setMessage(res.data?.message || "Email verified successfully. Redirecting...");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        setMessage(res.data?.message || "Invalid verification code.");
      }
    } catch (err) {
      setMessage(err.response?.data?.message || "Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      const res = await api.post("/auth/resend-code", { email });
      setMessage(res.data?.message);
      setTimer(60);
    } catch (err) {
      setMessage(err.data.message);
    }
  };

  return (
    <>
      {/* <Navbar /> */}

      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="card shadow-sm border-0" style={{ maxWidth: 420, width: "100%" }}>
          <div className="card-body p-4 text-center">

            {/* BRAND */}
            <div className="mb-3">
              <img
                src="https://ssl.gstatic.com/ui/v1/icons/mail/rfr/logo_gmail_lockup_default_1x_r5.png"       // replace with your real logo
                alt="Brand Logo"
                height="40"
                className="mb-2"
              />
            </div>

            {/* SUCCESS BADGE */}
            {success && (
              <div className="alert alert-success fw-semibold">
                ✓ Verified
              </div>
            )}

            <h4 className="fw-bold mb-2">Verify your email</h4>

            <p className="text-muted small mb-4">
              We sent a 6-digit verification code to
              <br />
              <strong>{maskEmail(email)}</strong>
            </p>
            {/* MESSAGE */}
            {message && (
              <div
                className={`alert mt-3 py-2 small ${
                  success ? "alert-success" : "alert-danger"
                }`}
              >
                {message}
              </div>
            )}
            <form onSubmit={handleVerify}>
              <div className="mb-3 text-start">
                <label className="form-label small fw-semibold">
                  Verification Code
                </label>
                <input
                  ref={inputRef}
                  type="text"
                  className="form-control text-center fs-5"
                  placeholder="••••••"
                  maxLength={6}
                  value={code}
                  disabled={loading || success}
                  onChange={(e) =>
                    setCode(e.target.value.replace(/\D/g, ""))
                  }
                  style={{ letterSpacing: "6px" }}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 fw-semibold"
                disabled={loading || code.length !== 6}
              >
                {loading ? "Verifying…" : "Verify Email"}
              </button>
            </form>

            {/* RESEND */}
            <div className="mt-3 small">
              {timer > 0 ? (
                <span className="text-muted">
                  Resend available in {timer}s
                </span>
              ) : (
                <button
                  onClick={handleResend}
                  className="btn btn-link p-0 fw-semibold"
                >
                  Resend code
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
